import { render, staticRenderFns } from "./invoice-pdf.vue?vue&type=template&id=616503da&"
import script from "./invoice-pdf.vue?vue&type=script&lang=ts&"
export * from "./invoice-pdf.vue?vue&type=script&lang=ts&"
import style0 from "./invoice-pdf.vue?vue&type=style&index=0&id=616503da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports